import { OrderBookingData } from 'entities/orders/model/types';

export const compareOrderChanges = (
	prevState: OrderBookingData | undefined,
	state: OrderBookingData,
) => {
	return (
		prevState?.dt_start === state.dt_start &&
		prevState?.bypass === state.bypass &&
		prevState?.hold_resources === state.hold_resources &&
		prevState?.duration === state.duration &&
		prevState?.participants_count === state.participants_count
	);
};
